<template>
  <!-- 新增的对话框 -->
  <el-dialog
    center
    width="860px"
    title="编辑三级分销率"
    :visible.sync="dialogFormVisible"
    @close="resetFrom('editForm')"
  >
    <el-form :model="editForm" :rules="editRules" ref="editForm">
   
    <el-form-item label="等级" :label-width="formLabelWidth" prop="number">
        <el-input v-model="editForm.number"  autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="第一比率" :label-width="formLabelWidth" prop="firRate">
        <el-input v-model="editForm.firRate"  autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="第二比率" :label-width="formLabelWidth" prop="secRate">
        <el-input v-model="editForm.secRate"  autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="第三比率" :label-width="formLabelWidth" prop="thrRate">
        <el-input v-model="editForm.thrRate"  autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item label="描述" :label-width="formLabelWidth" prop="desc">
        <el-input v-model="editForm.desc"  autocomplete="off"></el-input>
    </el-form-item>
 

    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button
        @click="onCancel"
        >取 消</el-button>
      <el-button type="primary" @click="submitEdit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { editMultiApi } from '@/api/money.js'
export default {
  name: 'editMulti',
  data () {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      dialogFormVisible: false,
      editForm: {}, // 编辑表单
      editRules: {
            number: [{ required: true, message: "等级不能为空", trigger: "blur" }],
            firRate: [{ required: true, message: "第一比率为空", trigger: "blur" }],
            secRate: [{ required: true, message: "第二比率不能为空", trigger: "blur" }],
            thrRate: [{ required: true, message: "第三比率不能为空", trigger: "blur" }],
        }, // 表单的验证规则,
    }
  },
  inject: ['reload'],
  methods: {
    submitEdit () {
      try {
        this.$refs.editForm.validate(async valid => {
          if (!valid) return this.$message.error('格式不对哦，检查一下呗!')
         let { firRate, secRate, thrRate } = this.editForm
         firRate = Number(firRate)
         secRate = Number(secRate)
         thrRate = Number(thrRate)
         if( (firRate+secRate+thrRate) > 1) return this.$message.error('三级分销率不能大于1')
          await editMultiApi({ ...this.editForm,firRate,secRate,thrRate }).then(res => {
            if (res.code === 200) {
              this.$message.success('编辑成功!')
            } else {
              this.$message.error('编辑失败!')
              return
            }
          })
          this.dialogFormVisible = false
          this.editForm = {}
          // 重新获取数据
          this.reload()
        })
      } catch (e) {
        window.console.log(e)
      }
    },
    onCancel() {
      this.dialogFormVisible = false
    }
  }
}
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  min-height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 200px;
  display: block;
}

.toolbar {
  border: 1px solid #ccc;
  width: 100%;
}

.el-form-item {
  margin-bottom: 5px;
}

.content {
  border: 1px solid #ccc;
  width: 100%;
  height: 200px;
}
</style>
